import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Industries() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-red-600 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-600 rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <h1 className="text-5xl lg:text-6xl font-bold mb-6">Industries Served</h1>
          <p className="text-xl text-slate-200 max-w-3xl">
            Supporting critical supply chains across automotive, infrastructure, and facilities sectors.
          </p>
        </div>
      </section>

      {/* Single Industries Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-6">Supply Chain Support Across Key Sectors</h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              DFF Distribution serves organizations that keep communities running—from municipal operations to commercial facilities and infrastructure maintenance.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-slate-50 p-8 rounded-lg border border-slate-200">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 text-white rounded-md mb-6">
                <i className="ri-car-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-semibold text-slate-900 mb-4">Automotive & Fleet</h3>
              <p className="text-slate-600 leading-relaxed mb-4">
                Supporting municipal fleet operations, commercial vehicle maintenance, and government service departments with authorized automotive parts and supplies.
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>City and township fleet maintenance</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Commercial fleet service operations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Government vehicle maintenance facilities</span>
                </li>
              </ul>
            </div>

            <div className="bg-slate-50 p-8 rounded-lg border border-slate-200">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 text-white rounded-md mb-6">
                <i className="ri-road-map-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-semibold text-slate-900 mb-4">Infrastructure & Public Works</h3>
              <p className="text-slate-600 leading-relaxed mb-4">
                Providing equipment and materials for public infrastructure maintenance, utility operations, and municipal services that serve communities.
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Municipal public works departments</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Utility service and maintenance operations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Infrastructure maintenance contractors</span>
                </li>
              </ul>
            </div>

            <div className="bg-slate-50 p-8 rounded-lg border border-slate-200">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 text-white rounded-md mb-6">
                <i className="ri-tools-line text-2xl"></i>
              </div>
              <h3 className="text-2xl font-semibold text-slate-900 mb-4">Hardware & Facilities</h3>
              <p className="text-slate-600 leading-relaxed mb-4">
                Supplying hardware, tools, and maintenance materials for commercial facilities, institutional buildings, and contract maintenance providers.
              </p>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Commercial building maintenance operations</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Institutional facilities management</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-line text-slate-400 mt-0.5 flex-shrink-0"></i>
                  <span>Contract maintenance service providers</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white p-12 rounded-lg relative overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 right-0 w-64 h-64 bg-red-600 rounded-full blur-3xl"></div>
            </div>
            <div className="relative z-10 text-center max-w-3xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">Consistent Standards Across All Industries</h3>
              <p className="text-slate-200 leading-relaxed">
                Regardless of sector, we maintain the same commitment to <strong>compliance, documentation, traceability, and reliable fulfillment</strong>. Our veteran-owned leadership brings operational discipline to every partnership.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-slate-900 mb-6">
            Explore Partnership Opportunities
          </h2>
          <p className="text-xl text-slate-600 mb-10 leading-relaxed">
            Connect with DFF Distribution to discuss how we can support your industry-specific supply needs.
          </p>
          <Link 
            to="/contact" 
            className="whitespace-nowrap inline-flex items-center justify-center px-10 py-4 bg-slate-900 text-white font-semibold rounded-md hover:bg-slate-800 transition-colors cursor-pointer text-lg"
          >
            Contact Our Team
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}